export default {
    clientGuid: process.env.HAWKSEARCH_CLIENT_GUID,
    apiUrl: process.env.HAWKSEARCH_API_URL,
    indexName: process.env.HAWKSEARCH_INDEX_NAME,
};
